import React from 'react';
import BasicTag from '../BasicTag';
import { BsFillLightningChargeFill } from 'react-icons/bs';

const CircuitTag = () => {
  return (
    <BasicTag color="purple" text="電路群組" Icon={BsFillLightningChargeFill} />
  );
};

export default CircuitTag;
